import React from 'react';

const CustomProtocolOpenerComponent =
() => {
  return (
    <iframe
      data-protocol-opener style={{ display: 'none' }}
      src="about:blank"
    />
  );
};


export default CustomProtocolOpenerComponent;


// WEBPACK FOOTER //
// src/Components/CustomProtocolOpenerComponent.jsx